// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchStrategy_container__21dXg","resetIcon":"SearchStrategy_resetIcon__3_Pb0"};